import { ErrorHandler, Injector, inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { Auth2Service } from './auth/auth2.service';
import { ToastService } from './shared/toast.service';

@Service({ autoProvided: false })
export class HttpErrorHandler extends ErrorHandler {
  readonly #injector = inject(Injector);

  get auth2Service(): Auth2Service {
    return this.#injector.get(Auth2Service);
  }

  get router(): Router {
    return this.#injector.get(Router);
  }

  get toastService(): ToastService {
    return this.#injector.get(ToastService);
  }

  override handleError(error: any) {
    if (error?.status == 401 || error?.status == 403) {
      if (!this.auth2Service.isTokenExpired()) {
        this.showError(
          'Accès non autorisé',
          "Veuillez vérifier votre mot de passe ou si vous avez le droit d'accèder à cette page. (" +
            error.statusText +
            ')'
        );
      } else {
        this.showError(
          'Accès non autorisé',
          'Votre compte est actuellement bloqué'
        );
      }
      this.auth2Service.logout();

      void this.router.navigate(['/login']);

      return;
    }
    console.error(error);
    // this.auth2Service.logout(); // force cleanup token

    if (error?.error) {
      // let data = JSON.parse(error.error);
      this.showError(
        'Cette opération a produit une erreur.',
        error.error.exception
      );
    } else if (error) {
      this.showError(
        'Oups !',
        'Veuillez contacter le support, si cette erreur réapparait. ' +
          error.status +
          ' (' +
          error.statusText +
          ')'
      );
    }

    return error;
  }

  private showError(title: string, message: string) {
    this.toastService.error({ title, message });
  }
}
